export const BANNER_NAME_MAX = 50;

/**
 * [EN] 32 / 49 come from the consumer's own measurement: both are what fits at the width where the
 *      banner card is narrowest (a 1200px desktop, card 552px) — see `BannerFace` in
 *      closet-public-web. Shortening them would waste the wide layout; lengthening them cuts text
 *      off on the most common laptop widths.
 * [KO] 32 / 49 는 소비자 쪽 실측값이다. 배너 카드가 가장 좁아지는 폭(1200px 데스크탑 · 카드
 *      552px)에서 온전히 담기는 길이다 — closet-public-web 의 `BannerFace` 참고. 줄이면 넓은
 *      화면의 자리가 남고, 늘리면 가장 흔한 노트북 폭에서 끝이 잘린다.
 */
export const TEXT_TITLE_MAX = 32;
export const TEXT_SUBTITLE_MAX = 49;

export const LINK_URL_MAX = 200;

export const IMAGE_MAX_MB = 10;

/**
 * [EN] `image/jpeg` covers both .jpg and .jpeg — browsers report one type for both extensions, so
 *      a separate `image/jpg` entry would never match.
 * [KO] `image/jpeg` 하나가 .jpg 와 .jpeg 를 함께 받는다. 브라우저가 두 확장자에 같은 타입을
 *      주므로 `image/jpg` 를 따로 넣어도 걸리는 파일이 없다.
 */
export const IMAGE_ACCEPT_TYPES = ['image/jpeg', 'image/png'];

/**
 * [EN] The card the consumer renders is 2.225 : 1 (`CARD_ASPECT_RATIO` in `TopBannerStrip`).
 *      1600 × 720 (2.222 : 1) is the size the guide text promises — a round number within
 *      `IMAGE_ASPECT_RATIO_TOLERANCE`, so an image made to it never triggers the ratio warning.
 * [KO] 소비자가 그리는 카드는 2.225 : 1 이다 (`TopBannerStrip` 의 `CARD_ASPECT_RATIO`).
 *      1600 × 720 (2.222 : 1) 은 안내 문구에 쓰는 사이즈로, `IMAGE_ASPECT_RATIO_TOLERANCE` 안에
 *      드는 반올림 값이라 이 크기로 만든 이미지에는 비율 경고가 뜨지 않는다.
 */
export const IMAGE_ASPECT_RATIO = 2.225;
export const RECOMMENDED_IMAGE_WIDTH = 1600;
export const RECOMMENDED_IMAGE_HEIGHT = 720;

/**
 * [EN] How far off the ratio may be before the form warns. 2% is roughly the crop `object-fit:
 *      cover` hides without anyone noticing; below that a warning would only be noise.
 * [KO] 경고를 띄우기 시작하는 비율 오차. 2% 는 `object-fit: cover` 가 티 없이 삼키는 정도라,
 *      그 아래에서 경고를 띄우면 잡음이 된다.
 */
export const IMAGE_ASPECT_RATIO_TOLERANCE = 0.02;

export const SHOWING_BANNER_MAX = 10;
